import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithAuth } from 'services/baseQueryWithAuth';

export const baseApi = createApi({
  reducerPath: 'baseApi',
  baseQuery: baseQueryWithAuth,
  tagTypes: ['Donors'],
  endpoints: () => ({}),
});
